exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\r\n    width: 400px;\r\n}\r\n\r\n.container div:nth-last-child(){\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/dialog-close-asker/dialog-close-asker.component.css
// module id = ../../../../../src/app/components/dialog-close-asker/dialog-close-asker.component.css
// module chunks = main